import { createApp } from "vue";
import axios from 'axios';
import VueAxios from 'vue-axios';
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { createHead } from "@vueuse/head";
import VueGtag from "vue-gtag";

/* vue-gtag */
// 1. npm i vue-gtag
// 2. import VueGtag from "vue-gtag";

/* FontAwesome */
import { library } from '@fortawesome/fontawesome-svg-core'
// 要用的符號要這邊一個一個import
import { faAngleDown, faComment, faChartBar, faNoteSticky, faCamera, faLink } from '@fortawesome/free-solid-svg-icons'
import { faFacebookSquare, faTwitterSquare, faYoutubeSquare, faInstagramSquare } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(faFacebookSquare, faTwitterSquare, faYoutubeSquare, faInstagramSquare, faAngleDown, faComment, faChartBar, faNoteSticky, faCamera, faLink)

/* VeeValidate */
// npm install vee-validate @vee-validate/rules @vee-validate/i18n
import { Field, Form, ErrorMessage, defineRule, configure } from 'vee-validate';
import { required, email, min } from '@vee-validate/rules';
import { localize, setLocale } from '@vee-validate/i18n';
import zhTW from '@vee-validate/i18n/dist/locale/zh_TW.json';
defineRule('required', required);
defineRule('email', email);
defineRule('min', min);
configure({
  generateMessage: localize({ zh_TW: zhTW }),
  validateOnInput: true,
});
setLocale('zh_TW')

/* Vue Meta (Vue3 不能用，但有 alpha 版本)*/
// 1. npm i vue-meta
// 2. import VueMeta from 'vue-meta'; 和 app.use(VueMeta);
/* 改用 vueuse/head(但還是無法用og:image，看來一定要用 nunx 才可以) */
// 1. npm i @vueuse/head
// 2. import { createHead } from "@vueuse/head"
// 3. const head = createHead(); 和 app.use(head);

const app = createApp(App);
const head = createHead();
app.use(head);

app.use(VueGtag, {
  config: { id: "UA-30958556-35" }
}, router);
app.use(store);
app.use(router);
app.use(VueAxios, axios);
app.component('font-awesome-icon', FontAwesomeIcon);
app.component('Form', Form);
app.component('Field', Field);
app.component('ErrorMessage', ErrorMessage);

app.mount("#app");
